 import find from 'lodash/find';

 export class DonationService {
     constructor($resource, ApiService) {
         'ngInject';

        this.$resource = $resource;
		this.apiService = ApiService;

        this.donationResourceUrl = this.apiService.getResourceUrl('cms/menus/Donation');
        this.editDonationResourceUrl = this.apiService.getResourceUrl('cms/donation');

        this.donationResource = this.$resource(this.donationResourceUrl);
        this.editDonationResource = this.$resource(this.editDonationResourceUrl,null,{
            update: {
                method: 'PUT'
            }
        });
     }

     _getSubContentDetails(value) {
        return {
			id: value.content_id,
			url: value.url
		}
    }

    _setSubContentDetails(value) {
		return {
			url: value.url
		}
	}

     /************
      * To get Donation
      ***************/
      getDonationUrl(details) {
        return this._getSubContentDetails(find(details.data.content, ['name', 'Donation']).values[0]);
      }

      /*************
       * To Update Donation
       *****************/
      editDonation(details) {
        const promise = this.editDonationResource.update(this._setSubContentDetails(details)).$promise;

        return promise
            .then(details => details)
            .catch(err => {
                throw this.apiService.getErrorMessage(err);
            })
      }
 }


// WEBPACK FOOTER //
// ./src/app/components/donation/donation.service.js